import {
  compose, hoistStatics, withHandlers,
} from 'recompose';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { withNamespaces } from 'react-i18next';

import DeleteFileModal from './deleteFileModal';
import { getModal } from '../../../../state/ui/selectors';
import { closeModal } from '../../../../state/ui/actions';
import { taskActions, taskSelectors } from '../../../../state/task';

const mapStateToProps = state => ({
  isOpen: getModal(state)('deleteTaskFileModal'),
  task: taskSelectors.getActiveTask(state),
});

const mapDispatchToProps = {
  deleteTaskFileRequest: taskActions.deleteTaskFileRequest,
  onCloseModal: () => closeModal('deleteTaskFileModal'),
};

const onDeleteTaskFileHandler = ({
  deleteTaskFileRequest,
  match: { params: { id, taskId } },
  onCloseModal,
  fileId,
}) => () => deleteTaskFileRequest({
  projectId: id,
  taskId,
  fileId,
}, {
  callbacks: {
    success: onCloseModal,
  },
});

const enhance = compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
  withNamespaces(['tasks', 'common']),
  withRouter,
  withHandlers({
    onDeleteTaskFile: onDeleteTaskFileHandler,
  }),
  hoistStatics,
);

export default enhance(DeleteFileModal);
